<h2 class="display-5 result-count">
    <ng-container *ngIf="total; else zeroResults">
        <span
            *ngIf="searchTerm; else allResults"
            [innerHTML]="
                'filter.searchResultCount'
                    | translateSafe
                    | formatString
                        : {
                              result: total.toString(),
                              category: '<span class=\'text-color-black\'>' + searchTerm + '</span>'
                          }
                    | safe: 'html'
            "
        ></span>
        <ng-template #allResults>
            {{ 'filter.searchResultAll' | translateSafe }}
        </ng-template>
    </ng-container>
    <ng-template #zeroResults>
        {{ 'filter.resultCount' | translateSafe | formatString: { result: '0' } }}
    </ng-template>
</h2>
